import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const DownloadCedarGeteForm = (FileID) => {
  const params = { FileID };
  const responseType = "blob";

    let res = Services.GETSERVICE(
      `/api/CedarGate/DownloadCedarGeteForm?CedarGateFormID=${FileID}`,
      {params},
      {responseType}
    );
    return res;
};

export const GetCedarGeteForm = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GETCEDARGETEFORM, token);
  return res;
};

export const GetDentalFunding = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GETDENTALFUNDING, token);
  return res;
};

export const GetMedicalfunding = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GETMEDICALFUNDING, token);
  return res;
};

export const GetAnalyticsFunding = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GETANALYTICSFUNDING, token);
  return res;
};

export const GetSalesForceVendorList = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.VENDOR_FROM_SALES_FORCE, token);
  return res;
};

export const SaveCedarGateFormData = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.SAVECEDARGATEFORMDATA, payload, token);
  return res;
};
export const UpdateCedarGateFormData = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.PUT(Url.UPDATECEDARGATEFORMDATA, payload, token);
  return res;
};


export const DeleteCedarGeteForm = async (id) => {
  const token = localStorage.getItem("token");
  const params = { id };
  let res = await Services.DELETE(Url.DELETECEDARGATEFORMDATA + id, params, token);
  return res;
};
